import Vue from 'vue'
import Vuex from 'vuex'
import language from '../modules/language'

Vue.use(Vuex)
export const store = new Vuex.Store({
    modules: {
        language
    },
    state: {
        locale: 'kr',
        fromScroll: 0,
        businessType: 0,
        navOpen: false
    },
    getters: {
        getLocale: function (state) {
            return state.locale
        },
        getFromScroll: function (state) {
            return state.fromScroll
        },
        getBusinessType: function (state) {
            return state.businessType
        },
        getNavOpen: function (state) {
            return state.navOpen
        }
    },
    mutations: {
        setLocale: function (state, payload) {
            state.locale = payload
        },
        setFromScroll: function (state, payload) {
            state.fromScroll = payload
        },
        setBusinessType: function (state, payload) {
            state.businessType = payload
        },
        setNavOpen: function (state, payload) {
            state.navOpen = payload
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js